define.alias("shared/components/shared/media-items/post-card", "media/components/shared/media-items/post-card");